// Stable markers the backend prefixes onto the "seat limit reached" errors and
// the frontend matches to show a targeted message (contact support vs. guest
// limit reached) instead of a generic invite failure. Shared so the contract
// can't drift between the two.
export const WORKSPACE_CORE_LIMIT_REACHED_CODE = "WORKSPACE_CORE_LIMIT_REACHED";
export const WORKSPACE_GUEST_LIMIT_REACHED_CODE = "WORKSPACE_GUEST_LIMIT_REACHED";
// A membership's account type. CORE members are full seats subject to the core
// cap; GUEST members are extra seats subject to a separate (default unlimited)
// cap and cannot create or delete workspace content.
export const ACCOUNT_TYPE = {
    CORE: "CORE",
    GUEST: "GUEST",
};
export const ACCOUNT_TYPE_LIST = [ACCOUNT_TYPE.CORE, ACCOUNT_TYPE.GUEST];
export function isAccountType(value) {
    return ACCOUNT_TYPE_LIST.includes(value);
}
// Normalizes a possibly-absent/unknown accountType to a valid one. The column is
// NOT NULL DEFAULT 'CORE', so an absent or unrecognized value resolves to CORE
// (allow-all) — a member is never wrongly treated as a guest.
export function resolveAccountType(value) {
    return value && isAccountType(value) ? value : ACCOUNT_TYPE.CORE;
}
// Core cap of a workspace during the userLimit -> coreUserLimit expand/contract:
// the authoritative coreUserLimit, falling back to the legacy userLimit column.
export function resolveCoreUserLimit(source) {
    return source.coreUserLimit ?? source.userLimit ?? null;
}
// Creation defaults for the per-type caps on a brand-new workspace. Existing
// workspaces keep their current cap (unlimited); only superuser_createWorkspace
// applies these when the input omits the fields. Guest defaults to null
// (unlimited). Kept in the shared package so the backend resolver and the
// frontend form pre-fill cannot drift.
export const DEFAULT_NEW_WORKSPACE_CORE_USER_LIMIT = 20;
export const DEFAULT_NEW_WORKSPACE_GUEST_USER_LIMIT = null;
